// PAQUETES
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Carousel from "react-bootstrap/Carousel";
// funciones
import { slugify, normalizarResumen } from "../../../funcionesDatos/Textos";
import { formatearMoneda } from "../../../funcionesDatos/Moneda";
import {partesYMDEnZona, ymdEnZona, obtenerYMActualEnZona, weekday1a7EnZona, hmEnZona, formatearFechaCalendario, formatearFechaHora, fechaHoraEnZonaAUTC} from "../../../funcionesDatos/fechas";
import { pixelIniciarReserva } from "../../../funcionesDatos/pixelFacebook";
import { gtagIniciarReserva } from "../../../funcionesDatos/pixelGoogle";
import { ttqIniciarReserva } from "../../../funcionesDatos/pixelTiktok";
import { eventoIniciarReserva } from "../../../funcionesDatos/eventoPropio";
import { esUrgente, esDemasiaPronto } from "../../../funcionesDatos/esUrgente";
import { obtenerIdInvitado } from "../../../funcionesDatos/idInvitado";
// estilos
import '../../../estilos/reserva.css';
import '../../../estilos/usuario.css'; // .botonReservar (CTA con pulso)
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import CardServicio from '../../../componentesEspeciales/cardServicio';
import CardVendedor from '../../../componentesEspeciales/cardVendedor';
import CabeceraPagos from "../../../componentesEspeciales/pagos/cabeceraPagos"; 
import PaqueteSeleccionado from "../../../componentesEspeciales/paqueteSeleccionado";
import ServicioPagoReserva from "../../../componentesEspeciales/pagos/servicioPagoReserva";
import Llamanos from "../../../componentesEspeciales/llamanos";

function Reserva() { 

  const navigate = useNavigate();
 
  const { usuario, cargandoUsuario, ahoraServidor } = useOutletContext() || {};
  const [cargando, setCargando]      = useState(false);
  const cargandoFinal                = Boolean(cargandoUsuario) || Boolean(cargando);

  const [reserva, setReserva]         = useState(null);
  const [ocupadas, setOcupadas]       = useState([]);
  const [idServicio, setidServicio]   = useState(null); 
  const [servicio, setServicio]       = useState(null);
  const [tipoPaquete, setTipoPaquete] = useState(null); // Básico, Premium, Avanzado
  const [zonaHoraria, setZonaHoraria] = useState("America/Bogota"); // inicializamos con bogota
  const [pais, setPais]               = useState("Colombia");
  const [precioPaquete, setPrecioPaquete] = useState(0);
 
  // --- Reseñas / vendedor (vienen junto con /buscar-servicio) ---
  const [valVendedor, setValVendedor]   = useState([]);
  const [vendedor, setVendedor]         = useState(null);
  const [resuServicio, setResuServicio] = useState({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });
  const [resuVendedor, setResuVendedor] = useState({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });

  // --- UI Reserva (boceto) ---
  const [paso, setPaso] = useState(1); // 1 seleccionar fecha, 2 pagar 
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null); // Date
  const [fechaFinSeleccionada, setFechaFinSeleccionada] = useState(null); // Date (solo DÍAS)
  const [horaSeleccionada, setHoraSeleccionada] = useState("");
  const [horarioExactoSeleccionado, setHorarioExactoSeleccionado] = useState(null);
  const [franjaSeleccionada, setFranjaSeleccionada] = useState("NA"); // manana|tarde|noche|NA
  const [divisaServicio, setDivisaServicio] = useState('COP');
  const [direccionReserva, setDireccionReserva] = useState("");
  const [referenciaReserva, setReferenciaReserva] = useState("");
  const [subzonaReserva, setSubzonaReserva] = useState("NA");

  // --- Countdown checkout (30 min) ---
  const [expiraEn, setExpiraEn] = useState(null); // ISO string or Date
  const [segundosRestantes, setSegundosRestantes] = useState(null); // number

  // Trigger para recargar datos (útil cuando cancelamos desde CabeceraPagos)
  const [refetchReserva, setRefetchReserva] = useState(0);
  const [desgloseCobro, setDesgloseCobro] = useState(null); // viene de /obtener-comisiones -> data.desglose

  const ultimoIdServicioCargadoRef = useRef(null);

  const ahoraParaReserva = useMemo(() => {
    const fecha = ahoraServidor ? new Date(ahoraServidor) : new Date();
    return Number.isNaN(fecha.getTime()) ? new Date() : fecha;
  }, [ahoraServidor]);


  const paqueteSeleccionado = useMemo(() => {
    const paquetesArr = servicio?.paquetes || [];

    if (tipoPaquete) {
      const encontrado = paquetesArr.find(p => (p?.tipo || '').toString() === tipoPaquete);
      if (encontrado) return encontrado;
    }

    // fallback: primer paquete
    return paquetesArr[0] || null;
  }, [servicio, tipoPaquete]);

  const modoAgenda    = paqueteSeleccionado?.modoAgenda || 'exacta';
  const unidadEntrega = paqueteSeleccionado?.unidadEntrega || 'Dias';
  const diasSemana    = Array.isArray(paqueteSeleccionado?.diasSemana) ? paqueteSeleccionado.diasSemana : [];
  const horariosDia   = Array.isArray(paqueteSeleccionado?.horariosDia) ? paqueteSeleccionado.horariosDia : [];
  const diasEntrega   = paqueteSeleccionado?.diasEntrega || 1; // cuantos días dura el servicio, si selecciono DÍAS como unidad.
  const citasDia      = Number(paqueteSeleccionado?.citasDia || 1);
  const duracionCitaMin = Number(paqueteSeleccionado?.duracionCitaMin || 0) || 60;

  const franjasDia = Array.isArray(paqueteSeleccionado?.franjasDia)
    ? paqueteSeleccionado.franjasDia
    : ["manana", "tarde", "noche"];

  const rangoFlexible = useMemo(
    () => rangoHoraPorFranja(franjaSeleccionada),
    [franjaSeleccionada]
  );

  const horasFlexibles = useMemo(
    () => generarHorasFranja(rangoFlexible.min, rangoFlexible.max, 15),
    [rangoFlexible]
  );

  const servicioPermiteUrgencia = !!servicio?.urgente;

  const esReservaUrgente = useMemo(() => {
    if (!servicioPermiteUrgencia) return false;
    if (!fechaSeleccionada) return false;

    if (unidadEntrega === 'Horas' && modoAgenda === 'exacta') {
      return esHorarioUrgente(fechaSeleccionada, horarioExactoSeleccionado);
    }

    if (unidadEntrega === 'Horas' && modoAgenda === 'flexible') {
      return esHorarioUrgente(fechaSeleccionada, horaSeleccionada);
    }

    return false; // urgente solo aplica a servicios por horas; no puede darse unidadEntrega !== 'Horas' con urgente activo
  }, [servicioPermiteUrgencia, fechaSeleccionada, unidadEntrega, modoAgenda, horarioExactoSeleccionado, horaSeleccionada, zonaHoraria, ahoraParaReserva]);
  
  // USEEFFECT PRINCIPAL
  useEffect(() => {
    (async () => {
    try {
      setCargando(true);
      // 1) Esperar a que Direccionamiento termine de verificar token
      if (cargandoUsuario) return;

      // buscar el hold activo: del comprador logueado, o del invitado si no hay sesión todavía
      const resReserva = await axios.post("/obtener-reserva", {
        params: usuario ? { idComprador: usuario.idUsuario } : { idInvitado: obtenerIdInvitado() }
      });

      // si NO existe una reserva activa, limpiamos estados
      if (!resReserva?.data?.existe) {
        setExpiraEn(null);
        setSegundosRestantes(null);
        setidServicio(null);
        setTipoPaquete(null);
        setServicio(null);
        setValVendedor([]);
        setVendedor(null);
        setResuServicio({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });
        setResuVendedor({ cantidad: 0, valoracionFinal: 0, cantidadEstrellas: 0 });
        setDesgloseCobro(null);
        setOcupadas([]);
        // reset UI selección
        setPaso(1);
        setFechaSeleccionada(null);
        setHorarioExactoSeleccionado(null);
        setFranjaSeleccionada("NA");
        setHoraSeleccionada("");
        setDireccionReserva("");
        setReferenciaReserva("");
        setSubzonaReserva("NA");
        ultimoIdServicioCargadoRef.current = null;
        return;
      }

      // si si existe una reserva
      if (resReserva.data.existe) {
        setReserva (resReserva.data.reserva);
        setOcupadas(Array.isArray(resReserva?.data?.ocupadas) ? resReserva.data.ocupadas : []); // reservas ocupadas
        //console.log("ocupada: ", resReserva?.data?.ocupadas);
        // buscamos el servicio
        let idDeServicio = resReserva.data.idServicio;
        setidServicio(idDeServicio);
        setTipoPaquete(resReserva.data.reserva.tipoPaquete); // guardamso el tipo de paquete
        setExpiraEn(resReserva?.data?.reserva?.expiraEn || null);

        const reservaActiva = resReserva?.data?.reserva || null;

        // Evitar re-cargar el mismo servicio varias veces
        if (ultimoIdServicioCargadoRef.current && String(ultimoIdServicioCargadoRef.current) === String(idDeServicio)) {
          return;
        }
        ultimoIdServicioCargadoRef.current = idDeServicio;

        const resServicio = await axios.post("/buscar-servicio", { params: { usuario: "NA", idServicio: idDeServicio } });
        const data = resServicio?.data || {};
        const srv = data?.servicio || null;

        setServicio(srv);
        // reseñas / vendedor
        setValVendedor(Array.isArray(data?.valoracionesVendedor) ? data.valoracionesVendedor : []);
        setVendedor(data?.usuarioVendedor || null);
        // ✅ Resumen del servicio: preferimos el nuevo formato: servicio.resumenReseñas
        setResuServicio(normalizarResumen({ resumenServicio: data?.resumenServicio, resumenReseñas: srv?.resumenReseñas }));
        // Resumen vendedor (por ahora viene en formato viejo desde backend)
        setResuVendedor(normalizarResumen({ resumenServicio: data?.resumenVendedor }));
        // obtener zona horaria
        setZonaHoraria(srv.zonaHoraria);
        // guardar divisa
        setDivisaServicio(srv.divisa);
        setDireccionReserva(reservaActiva?.direccion || "");
        setReferenciaReserva(reservaActiva?.referencia || "");
        setSubzonaReserva(reservaActiva?.subzona || "NA");


        // OBTENER DESGLOASE
        const paquetes         = srv.paquetes;
        const encontrarPaquete = paquetes.find(p => p.tipo === resReserva.data.reserva.tipoPaquete);
        const precioP = encontrarPaquete.precio;
        setPrecioPaquete(precioP);
        setPais(srv.pais); // guardamos para usar mas adelante el pais
        const d = await calcularDesglose(srv.pais, encontrarPaquete.precio, false); 
        setDesgloseCobro(d);
        //console.log("desglose: ", d);


        // --- Hidratar selección de calendario/hora desde la reserva ---
        if (reservaActiva) {
          // fecha (guardada en backend como Date)
          if (reservaActiva?.fecha) {
            const f = new Date(reservaActiva.fecha);
            if (!Number.isNaN(f.getTime())) {
              // usamos mediodía UTC para evitar problemas de DST al renderizar
              setFechaSeleccionada(new Date(Date.UTC(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate(), 12, 0, 0)));
            }
          }

          // Si el paquete es por horas:
          const modo = reservaActiva?.modoAgenda || 'exacta';

          if (modo === 'exacta') {
            const h = (reservaActiva?.horaConfirmada && reservaActiva.horaConfirmada !== 'NA')
              ? reservaActiva.horaConfirmada
              : null;
            if (h) {
              setHorarioExactoSeleccionado(String(h));
            }
            setFranjaSeleccionada('NA');
            setHoraSeleccionada('');
          } else if (modo === 'flexible') {
            const fr = (reservaActiva?.franja && reservaActiva.franja !== 'NA') ? reservaActiva.franja : 'NA';
            const hs = (reservaActiva?.horaSolicitada && reservaActiva.horaSolicitada !== 'NA') ? reservaActiva.horaSolicitada : '';
            setFranjaSeleccionada(fr);
            setHoraSeleccionada(String(hs || ''));
            setHorarioExactoSeleccionado(null);
          }
        }
      }
    } 
    catch (err) {
      console.log("Error en reserva:", err);
      Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error cargando la reserva." });
    }
    finally { setCargando(false); }
    })();
  }, [cargandoUsuario, usuario, navigate, refetchReserva]);

  useEffect(() => {
    if (!pais || !precioPaquete) return;

    let cancelado = false;

    (async () => {
      const d = await calcularDesglose(pais, precioPaquete, esReservaUrgente);
      if (!cancelado) {
        setDesgloseCobro(d);
      }
    })();

    return () => {
      cancelado = true;
    };
  }, [pais, precioPaquete, esReservaUrgente]);
  // CONTADOR EXPIRA EN
  useEffect(() => {
    if (!expiraEn) { setSegundosRestantes(null); return; }

    const exp = new Date(expiraEn).getTime(); //  convierte en un date y luego a milisegundos desde 1970 (timestamp) "2026-02-19T05:00:00Z" → 1708328400000.
    if (!Number.isFinite(exp)) { setSegundosRestantes(null); return; } // si falla la conversión entonces retorna

    const cuantoFalta = () => {
      const now = ahoraParaReserva.getTime(); // tiempo actual centralizado desde backend para pruebas
      const diffMs = exp - now; // cuantos milisegundos faltan: expiración - ahora.
      const s = Math.max(0, Math.floor(diffMs / 1000)); // convertimos a segundos.
      setSegundosRestantes(s);
    };

    cuantoFalta();

    const id = setInterval(cuantoFalta, 1000); // programamos la función para correr cada segundo. id es el identificador del intervalo.
    return () => clearInterval(id); // cuando se desmonta se limpia.
  }, [expiraEn, ahoraParaReserva]);

  



  // calcular desgloce
  async function calcularDesglose(pais, precioPaquete, urgente) {
    try {
      setCargando(true);

      const resDesglose = await axios.post("/obtener-comisiones", {
        params: { pais, precio: precioPaquete, urgente, idComprador: usuario?.idUsuario }
      });

      return resDesglose?.data?.desglose || null;
    } catch (err) {
      console.log(err);
      return null;
    } finally {
      setCargando(false);
    }
  }





  // --- Helpers calendario ---
  const diasNombres = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

  

 

  

  


  function ymd(d) { return ymdEnZona(d, zonaHoraria); }

  function ymdFechaGuardada(fecha) {
    if (!fecha) return "";

    const textoFecha = fecha instanceof Date ? fecha.toISOString() : String(fecha);
    const ymdGuardado = textoFecha.slice(0, 10);

    return /^\d{4}-\d{2}-\d{2}$/.test(ymdGuardado) ? ymdGuardado : "";
  }

  function rangoYmdReserva(reservaItem) {
    if (!reservaItem) return null;

    // En agenda flexible, la fecha confiable para pintar/bloquear el calendario es `fecha`
    // junto con `horaSolicitada`. `inicio/fin` puede venir calculado en UTC y mover el día
    // visualmente, por eso para flexibles priorizamos `fecha`.
    if (reservaItem?.modoAgenda === 'flexible' && reservaItem?.fecha) {
      const diaFlexible = ymdFechaGuardada(reservaItem.fecha);

      if (diaFlexible) {
        return {
          inicio: diaFlexible,
          fin: diaFlexible,
        };
      }
    }

    // Para agenda por HORAS, la referencia confiable del día es inicio/fin,
    // no `fecha` a medianoche UTC, porque al convertir a America/Bogota
    // puede correrse al día anterior.
    const inicioHoras = reservaItem?.inicio ? new Date(reservaItem.inicio) : null;
    const finHoras = reservaItem?.fin ? new Date(reservaItem.fin) : null;

    if (
      inicioHoras &&
      !Number.isNaN(inicioHoras.getTime()) &&
      finHoras &&
      !Number.isNaN(finHoras.getTime())
    ) {
      return {
        inicio: ymdEnZona(inicioHoras, zonaHoraria),
        fin: ymdEnZona(finHoras, zonaHoraria),
      };
    }

    if (inicioHoras && !Number.isNaN(inicioHoras.getTime())) {
      const mismoDia = ymdEnZona(inicioHoras, zonaHoraria);
      return {
        inicio: mismoDia,
        fin: mismoDia,
      };
    }

    // Fallback para servicios por DÍAS.
    // Para fechas calendario guardadas en BD usamos el YYYY-MM-DD original,
    // porque new Date('2026-04-29T00:00:00.000Z') en Colombia puede verse como 28.
    if (!reservaItem?.fecha) return null;

    const inicioYmd = ymdFechaGuardada(reservaItem.fecha);
    const finYmd = reservaItem?.fechaFin ? ymdFechaGuardada(reservaItem.fechaFin) : inicioYmd;

    if (!inicioYmd) return null;

    return {
      inicio: inicioYmd,
      fin: finYmd || inicioYmd,
    };
  }

  function reservaOcupaDia(reservaItem, dateObj) {
    if (!dateObj) return false;
    const rango = rangoYmdReserva(reservaItem);
    if (!rango) return false;

    const dia = ymd(dateObj);
    return dia >= rango.inicio && dia <= rango.fin;
  }

  function reservasDelDia(dateObj) {
    const lista = Array.isArray(ocupadas) ? ocupadas : [];
    return lista.filter((r) => reservaOcupaDia(r, dateObj));
  }

  

  function horaReservaOcupada(reservaItem) {
    if (!reservaItem) return '';

    if (reservaItem?.horaConfirmada && reservaItem.horaConfirmada !== 'NA') {
      return String(reservaItem.horaConfirmada);
    }

    if (reservaItem?.horaSolicitada && reservaItem.horaSolicitada !== 'NA') {
      return String(reservaItem.horaSolicitada);
    }

    if (reservaItem?.horarioExacto && reservaItem.horarioExacto !== 'NA') {
      return String(reservaItem.horarioExacto);
    }

    if (reservaItem?.inicio) {
      const inicio = new Date(reservaItem.inicio);
      if (!Number.isNaN(inicio.getTime())) {
        return hmEnZona(inicio, zonaHoraria);
      }
    }

    return '';
  }

  function rangoHoraReservaOcupada(reservaItem) {
    if (!reservaItem) return null;

    const inicioDate = reservaItem?.inicio ? new Date(reservaItem.inicio) : null;
    const finDate = reservaItem?.fin ? new Date(reservaItem.fin) : null;

    if (inicioDate && finDate && !Number.isNaN(inicioDate.getTime()) && !Number.isNaN(finDate.getTime())) {
      return {
        inicio: hmEnZona(inicioDate, zonaHoraria),
        fin: hmEnZona(finDate, zonaHoraria),
      };
    }

    const hora = horaReservaOcupada(reservaItem);
    if (!hora) return null;

    return { inicio: hora, fin: hora };
  }

  function horaOcupadaEnDia(dateObj, hora) {
    if (!dateObj || !hora) return false;

    const toMin = (hhmm) => {
      if (!hhmm || !String(hhmm).includes(':')) return null;
      const [hh, mm] = String(hhmm).split(':');
      return (Number(hh) * 60) + Number(mm);
    };

    const horaMin = toMin(hora);
    if (horaMin === null) return false;

    return reservasDelDia(dateObj).some((r) => {
      const rango = rangoHoraReservaOcupada(r);
      if (!rango?.inicio) return false;

      const inicioMin = toMin(rango.inicio);
      let finMin = toMin(rango.fin || rango.inicio);
      if (inicioMin === null || finMin === null) return false;

      // Sin fin conocido (solo hora): asumimos que dura lo mismo que la cita de este paquete.
      if (finMin === inicioMin) finMin = inicioMin + duracionCitaMin;
      // Cruza la medianoche (ej. 23:30–00:30): en este día ocupa hasta el final.
      if (finMin < inicioMin) finMin = 24 * 60;

      // La cita COMPLETA [hora, hora + duración) no puede cruzarse con lo ocupado (reservas, carritos
      // vigentes y bloqueos del vendedor), no solo su hora de inicio. Ej: 10:00–11:00 ocupada y citas
      // de 60 min → 09:30 también queda ocupada, porque terminaría a las 10:30.
      return horaMin < finMin && (horaMin + duracionCitaMin) > inicioMin;
    });
  }

  function quedanHorariosExactosDisponibles(dateObj) {
    if (!dateObj) return false;
    if (!Array.isArray(horariosDia) || horariosDia.length === 0) return false;

    return horariosDia.some((h) => {
      if (horaOcupadaEnDia(dateObj, h)) return false;
      if (esHorarioPasado(dateObj, h)) return false;
      if (esHorarioDemasiaPronto(dateObj, h)) return false;
      return true;
    });
  }

  function crearMes(year, monthIndex) {
    // monthIndex: 0-11 (interpretado como mes del servicio)
    // Usamos Date.UTC al mediodía para evitar efectos DST al formatear en zona.
    const first = new Date(Date.UTC(year, monthIndex, 1, 12, 0, 0));
    const last = new Date(Date.UTC(year, monthIndex + 1, 0, 12, 0, 0));

    // 1=Lun..7=Dom -> 0=Lun..6=Dom
    const startDay = weekday1a7EnZona(first, zonaHoraria) - 1;
    const totalDays = last.getUTCDate();

    const cells = [];
    for (let i = 0; i < startDay; i++) cells.push(null);
    for (let day = 1; day <= totalDays; day++) {
      cells.push(new Date(Date.UTC(year, monthIndex, day, 12, 0, 0)));
    }
    while (cells.length % 7 !== 0) cells.push(null);

    const weeks = [];
    for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

    return { first, weeks };
  }

  function nombreMes(dateObj) { return new Intl.DateTimeFormat('es-CO', { timeZone: zonaHoraria, month: 'long', year: 'numeric' }).format(dateObj); }

  function esDiaDisponible(dateObj) {
    if (!dateObj) return false;
    // ❌ Bloquear días/horas que no cumplan la anticipación mínima.
    // Si el servicio NO permite urgencia, la reserva debe empezar mínimo 24 horas después de ahora.
    // Si el servicio SÍ permite urgencia, solo bloqueamos fechas pasadas.
    const ahora = ahoraParaReserva; // Fecha centralizada desde backend para pruebas.
    const diaEvaluadoYMD = ymdEnZona(dateObj, zonaHoraria);
    const hoyYMD = ymdEnZona(ahora, zonaHoraria);

    if (servicioPermiteUrgencia) {
      if (diaEvaluadoYMD < hoyYMD) return false;
    } else {
      const limite24h = new Date(ahora.getTime() + (24 * 60 * 60 * 1000));
      const limite24hYMD = ymdEnZona(limite24h, zonaHoraria);

      if (diaEvaluadoYMD < limite24hYMD) return false;
    }

    const ocupadasDia = reservasDelDia(dateObj);

    // Si hay días de semana configurados (1-7 Lun-Dom), filtramos primero. Aplica tanto a
    // paquetes por Horas como por Días: el vendedor elige "qué días trabaja" en paso4.jsx y
    // DESPUÉS decide si ese día lo agenda por horas o por días completos — la restricción de
    // días de semana es independiente de esa elección.
    if (diasSemana && diasSemana.length > 0) {
      const mapTo = weekday1a7EnZona(dateObj, zonaHoraria);
      if (!diasSemana.includes(mapTo)) return false;
    }

    // Día bloqueado completo por el vendedor (/vendedor/agenda): no disponible en ningún modo.
    if (ocupadasDia.some((r) => r?.esBloqueo && r?.diaCompleto)) return false;

    // Si NO hay agenda por horas, bloqueamos cualquier día ya ocupado
    if (unidadEntrega !== 'Horas') return ocupadasDia.length === 0;

    // Agenda exacta: el día solo es seleccionable si queda al menos un horario libre
    // y, si no permite urgencia, alguno de esos horarios debe cumplir la anticipación mínima.
    if (modoAgenda === 'exacta') {
      if (!servicioPermiteUrgencia) {
        const ahora = ahoraParaReserva; // Fecha centralizada desde backend para pruebas.
        const limite24h = new Date(ahora.getTime() + (24 * 60 * 60 * 1000));

        const toMin = (hhmm) => {
          if (!hhmm || !String(hhmm).includes(':')) return null;
          const [hh, mm] = String(hhmm).split(':');
          return (Number(hh) * 60) + Number(mm);
        };

        const limiteMin = (() => {
          const hm = hmEnZona(limite24h, zonaHoraria);
          return toMin(hm);
        })();

        const diaLimiteYMD = ymdEnZona(limite24h, zonaHoraria);
        const diaActual = ymdEnZona(dateObj, zonaHoraria);

        const hayHorarioValido = (Array.isArray(horariosDia) ? horariosDia : []).some((h) => {
          if (horaOcupadaEnDia(dateObj, h)) return false;
          if (esHorarioPasado(dateObj, h)) return false;
          if (diaActual > diaLimiteYMD) return true;
          const hMin = toMin(h);
          if (hMin === null || limiteMin === null) return false;
          return hMin >= limiteMin;
        });

        return hayHorarioValido;
      }

      return quedanHorariosExactosDisponibles(dateObj);
    }

    // Agenda flexible: si ya se llenó el cupo del día, no se puede seleccionar.
    // Además, si no permite urgencia, el día debe tener al menos una hora válida >= al límite de 24h.
    const ocupadasDiaPaquete = ocupadasDia.filter(r => !r.esBloqueo && (r.tipoPaquete === tipoPaquete || !r.tipoPaquete));
    if (ocupadasDiaPaquete.length >= citasDia) return false;

    if (!servicioPermiteUrgencia) {
      const ahora = ahoraParaReserva; // Fecha centralizada desde backend para pruebas.
      const limite24h = new Date(ahora.getTime() + (24 * 60 * 60 * 1000));
      const diaLimiteYMD = ymdEnZona(limite24h, zonaHoraria);
      const diaActual = ymdEnZona(dateObj, zonaHoraria);

      if (diaActual < diaLimiteYMD) return false;
      if (diaActual > diaLimiteYMD) return true;

      const toMin = (hhmm) => {
        if (!hhmm || !String(hhmm).includes(':')) return null;
        const [hh, mm] = String(hhmm).split(':');
        return (Number(hh) * 60) + Number(mm);
      };

      const limiteMin = (() => {
        const hm = hmEnZona(limite24h, zonaHoraria);
        return toMin(hm);
      })();

      const horasDelDia = (Array.isArray(franjasDia) ? franjasDia : ["manana", "tarde", "noche"])
        .flatMap((franja) => {
          const rango = rangoHoraPorFranja(franja);
          return generarHorasFranja(rango.min, rango.max, 15);
        });

      return horasDelDia.some((h) => {
        const hMin = toMin(h);
        if (hMin === null || limiteMin === null) return false;
        if (hMin < limiteMin) return false;
        if (horaOcupadaEnDia(dateObj, h)) return false;
        if (esHorarioPasado(dateObj, h)) return false;
        return true;
      });
    }

    return true;
  }

  function esDiaUrgente(dateObj) {
    if (!dateObj) return false;

    const ahora = ahoraParaReserva; // Fecha centralizada desde backend para pruebas.
    const limite = new Date(ahora.getTime() + 24 * 60 * 60 * 1000);

    const diaYMD = ymdEnZona(dateObj, zonaHoraria);
    const hoyYMD = ymdEnZona(ahora, zonaHoraria);
    const limiteYMD = ymdEnZona(limite, zonaHoraria);

    return diaYMD >= hoyYMD && diaYMD <= limiteYMD;
  }
 
  function esHorarioUrgente(dateObj, hora) {
    if (!servicioPermiteUrgencia) return false;
    const fechaHora = fechaHoraEnZonaAUTC(dateObj, hora, zonaHoraria);
    if (!fechaHora) return false;
    return esUrgente(fechaHora, ahoraParaReserva);
  }

  function esHorarioDemasiaPronto(dateObj, hora) {
    if (!servicioPermiteUrgencia) return false;
    const fechaHora = fechaHoraEnZonaAUTC(dateObj, hora, zonaHoraria);
    if (!fechaHora) return false;
    return esDemasiaPronto(fechaHora, ahoraParaReserva);
  }

  function esHorarioPasado(dateObj, hora) {
    const fechaHora = fechaHoraEnZonaAUTC(dateObj, hora, zonaHoraria);
    if (!fechaHora) return false;

    return fechaHora < ahoraParaReserva;
  }

  function seleccionarFecha(d) {
    if (!d) return;

    // ✅ DÍAS: seleccionar rango según diasEntrega
    if (unidadEntrega !== 'Horas') {
      const n = Number(diasEntrega || 1);

      if (!esRangoDisponible(d, n)) {
        Swal.fire({
          icon: 'info',
          title: 'No disponible',
          text: `No puedes seleccionar ${n} día(s) continuos desde esa fecha. Elige otra fecha.`,
          customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' },
        });
        return;
      }

      setHoraSeleccionada('');
      setFechaSeleccionada(d);
      const fin = sumarDiasUTC(d, Math.max(1, n) - 1);
      setFechaFinSeleccionada(fin);

      // limpiar selección por horas
      setHorarioExactoSeleccionado(null);
      setFranjaSeleccionada('NA');
      setHoraSeleccionada('');
      return;
    }

    // ✅ HORAS: comportamiento normal
    if (!esDiaDisponible(d)) return;

    setHoraSeleccionada('');
    setHorarioExactoSeleccionado(null);
    setFechaSeleccionada(d);
    setFechaFinSeleccionada(null);
    setFranjaSeleccionada("NA");
    setHoraSeleccionada("");
  }

  // Guardar reserva y continuar a pagar

  async function continuarAPagar() {
    if (!idServicio) return;

    // Validaciones mínimas
    if (!fechaSeleccionada) {
      return Swal.fire({ icon: 'error', title: 'Falta la fecha', text: 'Selecciona una fecha para continuar.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
    }

    if (unidadEntrega === 'Horas' && modoAgenda === 'exacta' && !horarioExactoSeleccionado) {
      return Swal.fire({ icon: 'error', title: 'Falta el horario', text: 'Selecciona un horario disponible para continuar.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
    }

    if (unidadEntrega === 'Horas' && modoAgenda === 'flexible') {
      if (franjaSeleccionada === 'NA') {
        return Swal.fire({ icon: 'error', title: 'Falta la franja', text: 'Selecciona una franja (mañana/tarde/noche) para continuar.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
      }
      if (!horaSeleccionada) {
        return Swal.fire({ icon: 'error', title: 'Falta la hora', text: 'Selecciona una hora sugerida para continuar.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
      }
    }

    if (servicio?.tipoDesplazamiento === 'Domicilio') {
      if (!direccionReserva.trim()) {
        return Swal.fire({ icon: 'error', title: 'Falta la dirección', text: 'Ingresa la dirección donde se prestará el servicio.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
      }
      if (!referenciaReserva.trim()) {
        return Swal.fire({ icon: 'error', title: 'Falta la referencia', text: 'Ingresa una referencia para ayudar a ubicarte.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
      }
      if (!servicio?.coberturaCompletaCiudad && (!subzonaReserva || subzonaReserva === 'NA')) {
        return Swal.fire({ icon: 'error', title: 'Falta la subzona', text: 'Selecciona la subzona de la ciudad para continuar.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
      }
    }

    try {
      setCargando(true);

      // CREAMOS EVENTO PIXEL FACEBOOK INITIATCHECKOUT
      pixelIniciarReserva({
          nombre: servicio.nombre,
          id:     servicio.idServicio,
          precio: desgloseCobro?.totalCliente || precioPaquete || 0,
      });
      gtagIniciarReserva({
          nombre: servicio.nombre,
          id:     servicio.idServicio,
          precio: desgloseCobro?.totalCliente || precioPaquete || 0,
      });
      ttqIniciarReserva({
          nombre: servicio.nombre,
          id:     servicio.idServicio,
          precio: desgloseCobro?.totalCliente || precioPaquete || 0,
      });
      eventoIniciarReserva({
          nombre:    servicio.nombre,
          id:        servicio.idServicio,
          precio:    desgloseCobro?.totalCliente || precioPaquete || 0,
          usuarioId: usuario?.idUsuario,
      });



      const payload = {
        ...(usuario ? { idComprador: usuario.idUsuario } : { idInvitado: obtenerIdInvitado() }),
        idServicio,
        tipoPaquete: tipoPaquete, // "Básico" | "Premium" | "Avanzado"
        // Snapshot de agenda
        unidadEntrega,
        modoAgenda,
        // fecha/hora
        fecha: ymd(fechaSeleccionada), // fecha de inicio en ambos casos: dias y horas.
        fechaFin: unidadEntrega !== 'Horas' && fechaFinSeleccionada ? ymd(fechaFinSeleccionada) : 'NA',
        franja: modoAgenda === 'flexible' ? franjaSeleccionada : 'NA',
        horaSolicitada: modoAgenda === 'flexible' ? horaSeleccionada : 'NA',
        horaConfirmada: 'NA',
        // En exacta guardamos el horario seleccionado (como horaConfirmada por ahora)
        horarioExacto: modoAgenda === 'exacta' ? (horarioExactoSeleccionado || 'NA') : 'NA',
        direccion: servicio?.tipoDesplazamiento === 'Domicilio' ? direccionReserva.trim() : 'NA',
        referencia: servicio?.tipoDesplazamiento === 'Domicilio' ? referenciaReserva.trim() : 'NA',
        subzona: servicio?.tipoDesplazamiento === 'Domicilio' ? subzonaReserva : 'NA',
        paisUsuario: servicio?.tipoDesplazamiento === 'Domicilio' ? (servicio?.pais || 'NA') : 'NA',
        zonaUsuario: servicio?.tipoDesplazamiento === 'Domicilio' ? (servicio?.zona || 'NA') : 'NA',
        ciudadUsuario: servicio?.tipoDesplazamiento === 'Domicilio' ? (servicio?.ciudad || 'NA') : 'NA',
        desgloseCobro: desgloseCobro,
        urgente: esReservaUrgente 
      };

      const res = await axios.post('/actualizar-reserva', { params: payload });
      // console.log('actualizar-reserva:', res?.data);

      return navigate("/pago");
    }
    catch (err) {
      console.log('Error actualizando reserva:', err);
      Swal.fire({ icon: 'error', title: 'Error', text: 'No pudimos guardar tu reserva. Intenta de nuevo.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
    }
    finally { setCargando(false); }
  }

  


  function rangoHoraPorFranja(franja) {
    if (franja === "manana") return { min: "06:00", max: "12:00" };
    if (franja === "tarde")  return { min: "12:00", max: "18:00" };
    if (franja === "noche")  return { min: "18:00", max: "22:00" };
    return { min: "06:00", max: "22:00" };
  }

  function generarHorasFranja(min, max, pasoMin = 15) {
    if (!min || !max) return [];

    const toMin = (hhmm) => {
      const [hh, mm] = String(hhmm).split(":");
      return (Number(hh) * 60) + Number(mm);
    };

    const toHHMM = (mins) => {
      const hh = Math.floor(mins / 60);
      const mm = mins % 60;
      return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
    };

    const inicio = toMin(min);
    const fin = toMin(max);
    const horas = [];

    for (let actual = inicio; actual <= fin; actual += pasoMin) {
      horas.push(toHHMM(actual));
    }

    return horas;
  }


  function etiquetaFranja(f) {
    if (f === "manana") return "Mañana";
    if (f === "tarde") return "Tarde";
    if (f === "noche") return "Noche";
    return "—";
  }

  

  

  function sumarDiasUTC(dateObj, dias) {
    // dateObj viene en UTC al mediodía (como en crearMes)
    const base = new Date(dateObj.getTime());
    return new Date(Date.UTC(base.getUTCFullYear(), base.getUTCMonth(), base.getUTCDate() + dias, 12, 0, 0));
  }

  function esRangoDisponible(inicio, cantidadDias) {
    if (!inicio || !cantidadDias || Number(cantidadDias) <= 0) return false;
    const n = Math.max(1, Number(cantidadDias));
    for (let i = 0; i < n; i++) {
      const dia = sumarDiasUTC(inicio, i);
      if (!esDiaDisponible(dia)) return false;
    }
    return true;
  }









  return (
    <div className="container py-3">
    { cargandoFinal ? <ZonaCargando />
    :<div>
      <div className="mb-3">
        <h1 className="h3 mb-1">Reserva</h1>
        <p className="text-body-secondary mb-0" style={{ fontSize: 13 }}> Aquí puedes gestionar tu reserva y seleccionar la fecha y hora antes de continuar al pago. </p>
      </div>
      {/* Cabecera (Countdown + Timeline) */}
      {idServicio ? (
        <CabeceraPagos
          paso={paso}
          segundosRestantes={segundosRestantes}
          duracionSegundos={10 * 60}
          idComprador={usuario?.idUsuario}
          onCancelSuccess={() => setRefetchReserva((x) => x + 1)}
        />
      ) : null}
      {/* Tertiary: sin idServicio */}
      {!idServicio ? 
      <div className="alert alert-secondary" role="alert">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <div className="fw-semibold">Aún no has seleccionado un servicio</div>
            <div className="text-body-secondary">Ve a buscar un servicio para poder reservar.</div>
          </div>
          <button type="button" className="btn btn-dark" onClick={() => navigate("/busqueda")} > Ir a buscar </button>
        </div>
      </div>
      : null}




      {/* Paso 1 */}
      {idServicio && paso === 1 ? 
      <div className="row g-3">
        {/* Izquierda:*/}
        <div className="col-12 col-lg-7">
          

          

          {/* FOMRULARIO DATOS DEL DOMICILIO */}
          {servicio?.tipoDesplazamiento === 'Domicilio' ? (
            <div
              className="rounded-4 p-3 p-md-4 mb-3"
              style={{
                background: 'linear-gradient(180deg, rgba(var(--azul-logo-claro-rgb), 0.08) 0%, rgba(var(--blanco-rgb), 0.98) 100%)',
                border: '1px solid rgba(var(--azul-logo-claro-rgb), 0.18)',
                boxShadow: '0 10px 24px rgba(var(--azul-logo-fondo-rgb), 0.06)',
              }}
            >
              <div className="d-flex align-items-start gap-3 mb-3">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    background: 'linear-gradient(135deg, var(--azul-logo-claro) 0%, var(--azul-medio) 100%)',
                    color: 'var(--blanco)',
                    boxShadow: '0 8px 18px rgba(var(--azul-logo-claro-rgb), 0.22)',
                  }}
                >
                  <i className="bi bi-geo-alt-fill"></i>
                </div>

                <div>
                  <div className="fw-bold mb-1" style={{ fontSize: 18, color: 'var(--color-text-primary)' }}>
                    Datos para el domicilio
                  </div>
                  <div className="text-body-secondary" style={{ fontSize: 13, lineHeight: 1.5 }}>
                    Completa estos datos para que el proveedor sepa exactamente dónde prestar el servicio.
                  </div>
                </div>
              </div>

              <div
                className="rounded-3 px-3 py-2 mb-3"
                style={{
                  background: 'rgba(var(--naranja-cta-rgb), 0.10)',
                  border: '1px solid rgba(var(--naranja-cta-rgb), 0.22)',
                  color: 'var(--color-text-warning)',
                  fontSize: 12,
                }}
              >
                Esta información se usará para coordinar la visita a domicilio dentro de la cobertura del servicio.
              </div>

              <div
                className="rounded-3 p-3 mb-3"
                style={{
                  background: 'var(--color-bg-surface)',
                  border: '1px solid rgba(var(--azul-logo-claro-rgb), 0.14)',
                  boxShadow: 'inset 0 1px 2px rgba(var(--azul-logo-fondo-rgb), 0.04)',
                }}
              >
                <div className="fw-semibold mb-2" style={{ fontSize: 13, color: 'var(--color-text-primary)' }}>
                  Cobertura del servicio
                </div>

                <div className="row g-2">
                  <div className="col-12 col-md-4">
                    <div className="text-body-secondary" style={{ fontSize: 11, marginBottom: 4 }}>País</div>
                    <div className="fw-semibold" style={{ fontSize: 14 }}>{servicio?.pais || 'NA'}</div>
                  </div>

                  <div className="col-12 col-md-4">
                    <div className="text-body-secondary" style={{ fontSize: 11, marginBottom: 4 }}>Zona</div>
                    <div className="fw-semibold" style={{ fontSize: 14 }}>{servicio?.zona || 'NA'}</div>
                  </div>

                  <div className="col-12 col-md-4">
                    <div className="text-body-secondary" style={{ fontSize: 11, marginBottom: 4 }}>Ciudad</div>
                    <div className="fw-semibold" style={{ fontSize: 14 }}>{servicio?.ciudad || 'NA'}</div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label mb-1 fw-semibold" style={{ fontSize: 13 }}>Dirección</label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Ej: Calle 123 #45-67"
                  value={direccionReserva}
                  onChange={(e) => setDireccionReserva(e.target.value)}
                  style={{
                    borderRadius: 14,
                    border: '1px solid rgba(var(--azul-logo-claro-rgb), 0.16)',
                    background: 'var(--color-bg-surface)',
                    boxShadow: 'inset 0 1px 2px rgba(var(--azul-logo-fondo-rgb), 0.04)',
                  }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label mb-1 fw-semibold" style={{ fontSize: 13 }}>Referencia</label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Ej: Apartamento 402, portería azul"
                  value={referenciaReserva}
                  onChange={(e) => setReferenciaReserva(e.target.value)}
                  style={{
                    borderRadius: 14,
                    border: '1px solid rgba(var(--azul-logo-claro-rgb), 0.16)',
                    background: 'var(--color-bg-surface)',
                    boxShadow: 'inset 0 1px 2px rgba(var(--azul-logo-fondo-rgb), 0.04)',
                  }}
                />
              </div>

              {servicio?.coberturaCompletaCiudad ? (
                <div className="rounded-3 px-3 py-2" style={{ background: "rgba(var(--verde-esmeralda-rgb), 0.08)", border: "1px solid rgba(var(--verde-esmeralda-rgb), 0.2)", fontSize: 13, color: "var(--verde-oscuro-texto)" }}>
                  <i className="bi bi-check-circle-fill me-2" style={{ color: "var(--verde-esmeralda)" }}></i>
                  Este servicio cubre toda la ciudad de <strong>{servicio?.ciudad}</strong>.
                </div>
              ) : (
                <div>
                  <label className="form-label mb-1 fw-semibold" style={{ fontSize: 13 }}>Subzona</label>
                  <select
                    className="form-select form-select-lg"
                    value={subzonaReserva}
                    onChange={(e) => setSubzonaReserva(e.target.value)}
                    style={{
                      borderRadius: 14,
                      border: '1px solid rgba(var(--azul-logo-claro-rgb), 0.16)',
                      backgroundColor: 'var(--color-bg-surface)',
                      boxShadow: 'inset 0 1px 2px rgba(var(--azul-logo-fondo-rgb), 0.04)',
                    }}
                  >
                    <option value="NA">Selecciona una subzona</option>
                    {(Array.isArray(servicio?.subzonas) ? servicio.subzonas : []).map((subzona, idx) => (
                      <option key={`${subzona}-${idx}`} value={subzona}>{subzona}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          ) : null}

          <div className="mb-3">
            <ServicioPagoReserva servicio={servicio} reserva={reserva} />
          </div>

         
            

          {/* Vendedor */}
          {vendedor
          ?  <CardVendedor vendedor={vendedor} resuVendedor={resuVendedor} />
          : null}
        </div>

        

        {/* Derecha: calendario + selección */}
        <div className="col-12 col-lg-5">
          {/* LLÁMANOS: acompañamiento/confianza justo antes de elegir fecha/hora */}
          <div className="mb-3">
            <Llamanos />
          </div>

          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <h5 className="mb-2">Selecciona una fecha</h5>
              <div className="text-body-secondary" style={{ fontSize: 12, marginBottom: 8 }}>
                Horarios en zona del servicio: <span className="fw-semibold">{zonaHoraria}</span>
              </div>
              {servicioPermiteUrgencia ? (
                <div className="alert mb-3" style={{ backgroundColor: 'var(--naranja-muy-suave)', border: '1px solid var(--naranja-claro-borde)', color: 'var(--marron-oscuro)', fontSize: 13 }}>
                  Las reservas dentro de las próximas 24 horas se consideran urgentes y pueden tener un costo adicional.
                </div>
              ) : null}
              


              {/* CALENDARIOS */}
              {(() => {
                const { y: yNow, m: mNow } = obtenerYMActualEnZona(zonaHoraria, ahoraParaReserva);
                const m1 = crearMes(yNow, mNow - 1);

                const nextMonthIndex = (mNow - 1) + 1;
                const y2 = nextMonthIndex > 11 ? (yNow + 1) : yNow;
                const m2Index = nextMonthIndex % 12;
                const m2 = crearMes(y2, m2Index);

                const renderMes = (mes) => (
                  <div className="mb-4">
                    <div className="text-capitalize fw-semibold mb-2">{nombreMes(mes.first)}</div>

                    <div className="d-grid" style={{ gridTemplateColumns: 'repeat(7, 1fr)', gap: 6 }}>
                      {diasNombres.map((d) => (
                        <div key={`h-${d}`} className="text-center text-body-secondary" style={{ fontSize: 12 }}>
                          {d}
                        </div>
                      ))}

                      {mes.weeks.flat().map((cell, idx) => {
                        if (!cell) return <div key={`e-${idx}`} />;

                        const disponible = esDiaDisponible(cell);
                        const urgenteDia = servicioPermiteUrgencia ? esDiaUrgente(cell) : false;
                        const isSel = fechaSeleccionada && ymd(cell) === ymd(fechaSeleccionada);
                        const enRangoDias =
                          (unidadEntrega !== 'Horas' && fechaSeleccionada && fechaFinSeleccionada)
                            ? (ymd(cell) >= ymd(fechaSeleccionada) && ymd(cell) <= ymd(fechaFinSeleccionada))
                            : false;

                        const claseBtn = (isSel || enRangoDias)
                          ? 'btn-primary'
                          : (disponible ? (urgenteDia ? 'btn-warning' : 'btn-outline-secondary') : 'btn-light');

                        return (
                          <button
                            key={`d-${idx}`}
                            type="button"
                            className={`btn btn-sm ${claseBtn}`}
                            style={{
                              padding: '3px 0',
                              opacity: disponible ? 1 : 1,
                              border: disponible
                                ? (urgenteDia && !(isSel || enRangoDias) ? '1px solid var(--naranja-medio-claro)' : undefined)
                                : '1px solid var(--color-disabled-border)',
                              color: disponible
                                ? (urgenteDia && !(isSel || enRangoDias) ? 'var(--marron-oscuro)' : undefined)
                                : 'var(--color-disabled-text)',
                              background: disponible
                                ? (urgenteDia && !(isSel || enRangoDias) ? 'var(--naranja-muy-suave)' : undefined)
                                : 'var(--color-disabled-bg)',
                              cursor: disponible ? 'pointer' : 'not-allowed',
                            }}
                            disabled={!disponible}
                            onClick={() => seleccionarFecha(cell)}
                          >
                            {partesYMDEnZona(cell, zonaHoraria).d}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );

                return (
                  <>
                    {renderMes(m1)}
                    {renderMes(m2)}
                  </>
                );
              })()}






              {/* HORA */}
              <div className="mt-2">
                <div className="fw-semibold mb-1">Hora</div>
                {unidadEntrega === 'Horas' ?
                  modoAgenda === 'exacta' ? 
                  <>
                    <div className="text-body-secondary" style={{ fontSize: 13 }}>
                      {servicioPermiteUrgencia
                        ? 'Selecciona un horario disponible. Los horarios entre 2 y 24 horas desde ahora son urgentes (+35%).'
                        : 'Selecciona un horario disponible. Solo puedes reservar mínimo con 24 horas de anticipación.'}
                    </div>
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {horariosDia && horariosDia.length > 0 ? (
                        horariosDia.map((h) => {
                          const ocupado = fechaSeleccionada ? horaOcupadaEnDia(fechaSeleccionada, h) : false;
                          const urgenteHora = servicioPermiteUrgencia && fechaSeleccionada ? esHorarioUrgente(fechaSeleccionada, h) : false;
                          const pasado = fechaSeleccionada ? esHorarioPasado(fechaSeleccionada, h) : false;
                          const prontoDemas = fechaSeleccionada ? esHorarioDemasiaPronto(fechaSeleccionada, h) : false;

                          return (
                            <button
                              key={h}
                              type="button"
                              className={`btn btn-sm ${horarioExactoSeleccionado === h ? 'btn-primary' : (ocupado || pasado || prontoDemas ? 'btn-light' : (urgenteHora ? 'btn-warning' : 'btn-outline-secondary'))}`}
                              onClick={() => {
                                if (ocupado || pasado || prontoDemas) return;
                                setHorarioExactoSeleccionado(h);
                              }}
                              disabled={!fechaSeleccionada || ocupado || pasado || prontoDemas}
                              title={pasado ? 'Este horario ya pasó' : (prontoDemas ? 'Debes reservar con al menos 2 horas de anticipación' : (ocupado ? 'Este horario ya está ocupado' : (!fechaSeleccionada ? 'Primero selecciona una fecha' : '')))}
                              style={{
                                fontSize: 12,
                                padding: '3px 8px',
                                ...(urgenteHora && horarioExactoSeleccionado !== h && !ocupado && !pasado && !prontoDemas ? {
                                background: 'var(--naranja-muy-suave)',
                                borderColor: 'var(--naranja-medio-claro)',
                                color: 'var(--marron-oscuro)'
                              } : {}),
                              ...((ocupado || pasado || prontoDemas) ? { opacity: 0.5, cursor: 'not-allowed' } : {}),
                              }}
                            >
                              {h}{pasado ? ' · pasó' : (prontoDemas ? ' · muy pronto' : (ocupado ? ' · no disponible' : (urgenteHora ? ' · urgente' : '')))}
                            </button>
                          );
                        })
                      ) : (
                        <div className="text-body-secondary" style={{ fontSize: 13 }}>
                          Este paquete no tiene horarios configurados aún.
                        </div>
                      )}
                    </div>
                  </>
                  : <>
                    <div className="text-body-secondary" style={{ fontSize: 13 }}>
                      Selecciona una franja y una hora sugerida (el proveedor confirmará después).
                    </div>

                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {franjasDia.map((f) => (
                        <button
                          key={`fr-${f}`}
                          type="button"
                          className={`btn btn-sm ${franjaSeleccionada === f ? "btn-primary" : "btn-outline-secondary"}`}
                          onClick={() => {
                            setFranjaSeleccionada(f);
                            setHoraSeleccionada("");
                          }}
                        >
                          {etiquetaFranja(f)}
                        </button>
                      ))}
                    </div>

                    <div className="mt-2">
                      <div className="d-flex flex-wrap gap-2 mt-3">
                        {franjaSeleccionada === "NA" ?
                          <div className="text-body-secondary" style={{ fontSize: 12 }}>
                            Primero selecciona una franja.
                          </div>
                        : horasFlexibles.length > 0 ? 
                          horasFlexibles.map((h) => {
                            const ocupada = fechaSeleccionada ? horaOcupadaEnDia(fechaSeleccionada, h) : false;
                            const diaLleno = fechaSeleccionada ? reservasDelDia(fechaSeleccionada).filter(r => !r.esBloqueo && (r.tipoPaquete === tipoPaquete || !r.tipoPaquete)).length >= citasDia : false;
                            const urgenteHora = servicioPermiteUrgencia && fechaSeleccionada ? esHorarioUrgente(fechaSeleccionada, h) : false;
                            const pasada = fechaSeleccionada ? esHorarioPasado(fechaSeleccionada, h) : false;
                            const prontoDemas = fechaSeleccionada ? esHorarioDemasiaPronto(fechaSeleccionada, h) : false;

                            return (
                              <button
                                key={`hf-${franjaSeleccionada}-${h}`}
                                type="button"
                                className={`btn btn-sm ${horaSeleccionada === h ? 'btn-primary' : (ocupada || diaLleno || pasada || prontoDemas ? 'btn-light' : (urgenteHora ? 'btn-warning' : 'btn-outline-secondary'))}`}
                                onClick={() => {
                                  if (ocupada || diaLleno || pasada || prontoDemas) return;
                                  setHoraSeleccionada(h);
                                }}
                                disabled={!fechaSeleccionada || ocupada || diaLleno || pasada || prontoDemas}
                                title={
                                  pasada
                                    ? 'Esta hora ya pasó'
                                    : prontoDemas
                                      ? 'Debes reservar con al menos 2 horas de anticipación'
                                      : diaLleno
                                        ? 'Este día ya alcanzó el máximo de citas'
                                        : ocupada
                                          ? 'Esta hora ya está ocupada'
                                          : (!fechaSeleccionada ? 'Primero selecciona una fecha' : '')
                                }
                                style={{
                                  fontSize: 12,
                                  padding: '3px 8px',
                                  ...(urgenteHora && horaSeleccionada !== h && !ocupada && !diaLleno && !pasada && !prontoDemas ? {
                                    background: 'var(--naranja-muy-suave)',
                                    borderColor: 'var(--naranja-medio-claro)',
                                    color: 'var(--marron-oscuro)'
                                  } : {}),
                                  ...((ocupada || diaLleno || pasada || prontoDemas) ? {
                                    opacity: 0.65,
                                    cursor: 'not-allowed',
                                    color: 'var(--color-text-secondary)',
                                    borderColor: 'var(--color-border)',
                                    background: 'var(--color-bg-page)'
                                  } : {}),
                                }}
                              >
                                {h}{pasada ? ' · pasó' : (prontoDemas ? ' · muy pronto' : (diaLleno ? ' · día lleno' : (ocupada ? ' · ocupada' : (urgenteHora ? ' · urgente' : ''))))}
                              </button>
                            );
                          })
                        :<div className="text-body-secondary" style={{ fontSize: 12 }}>
                          No hay horas configuradas para esta franja.
                        </div>
                        }
                      </div>
                      {/* MENSAJE INFERIOR RANGO SUGERIDO */}
                      <div className="text-body-secondary" style={{ fontSize: 12, marginTop: 6 }}>
                        {franjaSeleccionada === "NA"
                          ? "Primero selecciona una franja."
                          : `Rango sugerido: ${rangoFlexible.min} - ${rangoFlexible.max}.`}
                      </div>
                    </div>
                  </>
                : <div className="text-body-secondary" style={{ fontSize: 13 }}>
                  Este servicio se agenda por días (sin horario exacto).
                </div>
                }
              </div>






              {/* RESUMEN */}
              <div className="mt-3 pt-3 border-top">
                <h6 className="mb-1">Resumen</h6>
                
                <div className="text-body-secondary" style={{ fontSize: 13 }}>
                  Fecha: {fechaSeleccionada ? ymd(fechaSeleccionada) : '—'}
                  {unidadEntrega !== 'Horas' && fechaSeleccionada && fechaFinSeleccionada ? ` → ${ymd(fechaFinSeleccionada)}` : ''}
                  {unidadEntrega === 'Horas' && modoAgenda === 'exacta' ? ` · Horario: ${horarioExactoSeleccionado || '—'}` : ''}
                  {unidadEntrega === 'Horas' && modoAgenda === 'flexible'
                    ? ` · Franja: ${franjaSeleccionada !== "NA" ? etiquetaFranja(franjaSeleccionada) : "—"} · Hora propuesta: ${horaSeleccionada || '—'}`
                    : ''}
                </div>

                {paqueteSeleccionado?.precio ? (
                  <div className="mt-3">

                    {/* Total que paga el cliente (desde backend) */}
                    <div
                      className="d-flex align-items-center justify-content-between rounded-3"
                      style={{
                        padding: '12px 14px',
                        background: 'rgba(var(--azul-bootstrap-cta-rgb), 0.08)',
                        border: '1px solid rgba(var(--azul-bootstrap-cta-rgb), 0.18)',
                      }}
                    >
                      <div>
                        <div className="fw-semibold">Total a pagar</div>
                        <div className="text-body-secondary" style={{ fontSize: 12 }}>
                          Incluye costos de servicio
                        </div>
                      </div>
                      <div className="fw-bold d-flex align-items-center justify-content-end gap-2" style={{ fontSize: 18 }}>
                        {(divisaServicio ) === 'COP' ? (
                          <span aria-label="Colombia" title="Colombia" style={{ fontSize: 16 }}>🇨🇴</span>
                        ) : null}
                        <span>
                          {desgloseCobro?.totalCliente
                            ? formatearMoneda(desgloseCobro.totalCliente, divisaServicio )
                            : formatearMoneda(paqueteSeleccionado.precio, divisaServicio )}
                        </span>
                      </div>
                    </div>

                    {/* BANNER DESTACADO: descuento primera compra */}
                    {desgloseCobro?.descuentoPrimeraCompraAplicado ? (
                      <div
                        className="d-flex align-items-center gap-2 rounded-3 mt-2"
                        style={{ padding: '10px 14px', background: 'var(--verde-esmeralda)', color: 'white' }}
                      >
                        <i className="bi bi-gift-fill" style={{ fontSize: 18 }} />
                        <div>
                          <div className="fw-bold" style={{ fontSize: 13 }}>¡Descuento de primera compra aplicado!</div>
                          <div style={{ fontSize: 12, opacity: 0.9 }}>
                            Ahorras {formatearMoneda(desgloseCobro?.descuentoPrimeraCompraMostrado, divisaServicio)} ({Math.round((desgloseCobro?.descuentoPrimeraCompraPct || 0) * 100)}%) por ser tu primera reserva
                            {!usuario ? ' — se confirma al iniciar sesión' : ''}
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {/* Desglose */}

                    {desgloseCobro ? (() => {
                      // Valores desde backend
                      //const ivaServicio           = formatearMoneda(desgloseCobro?.ivaServicio, divisaServicio );
                      const precioBaseProveedor   = formatearMoneda(desgloseCobro?.precioBaseProveedor, divisaServicio );
                      const totalServicio         = formatearMoneda(desgloseCobro?.totalServicio, divisaServicio );
                      const montoUrgencia         = formatearMoneda(desgloseCobro?.incrementoUrgencia, divisaServicio );
                      const pctUrgencia           = desgloseCobro?.incrementoUrgenciaPct * 100;
                      // Si hay descuento de primera compra, el "costo de servicio" que se muestra es el
                      // SIN descontar (comisión llena) — el descuento se resta aparte, en su propia línea,
                      // para que la suma de todas las líneas visibles cuadre exacto con el total a pagar.
                      const costoServicio         = formatearMoneda(
                        desgloseCobro?.descuentoPrimeraCompraAplicado
                          ? desgloseCobro?.costoDeServicioSinDescuento
                          : (desgloseCobro?.comisionHpm + desgloseCobro?.pasarela?.total),
                        divisaServicio
                      );
                      const totalCliente          = formatearMoneda(desgloseCobro?.totalCliente, divisaServicio );
                      const descuentoPrimeraCompra = formatearMoneda(desgloseCobro?.descuentoPrimeraCompraMostrado, divisaServicio );

                      return (
                        <div className="mt-2 border rounded-3 p-3" style={{ background: 'rgba(var(--negro-rgb), 0.02)' }}>
                          <div className="fw-semibold mb-2" style={{ fontSize: 12 }}>Desglose</div>

                          <div className="d-flex justify-content-between">
                            <span className="text-body-secondary textosDesgloce">Subtotal</span>
                            <span className="textosDesgloce">{precioBaseProveedor}</span>
                          </div>

                          {servicioPermiteUrgencia && Number(desgloseCobro?.incrementoUrgencia || 0) > 0 ? (
                            <div className="d-flex justify-content-between">
                              <span className="text-body-secondary textosDesgloce">Incremento de urgencia {pctUrgencia + "%"} </span>
                              <span className="textosDesgloce">{montoUrgencia}</span>
                            </div>
                          ) : null}

                          <div className="d-flex justify-content-between">
                            <span className="text-body-secondary textosDesgloce">Costo de servicio</span>
                            <span className="textosDesgloce">{costoServicio}</span>
                          </div>

                          {desgloseCobro?.descuentoPrimeraCompraAplicado ? (
                            <div className="d-flex justify-content-between">
                              <span className="fw-bold textosDesgloce" style={{ color: 'var(--verde-esmeralda)' }}>
                                <i className="bi bi-gift-fill me-1" />Descuento primera compra ({Math.round((desgloseCobro?.descuentoPrimeraCompraPct || 0) * 100)}%)
                              </span>
                              <span className="fw-bold textosDesgloce" style={{ color: 'var(--verde-esmeralda)' }}>-{descuentoPrimeraCompra}</span>
                            </div>
                          ) : null}

                          <hr className="my-2" />

                          <div className="d-flex justify-content-between">
                            <span className="fw-semibold textosDesgloce">Total a pagar</span>
                            <span className="fw-bold textosDesgloce">{totalCliente}</span>
                          </div>

                          <div className="text-body-secondary mt-2" style={{ fontSize: 12 }}>
                            Si necesitas factura o detalle de IVA, solicítalo directamente al proveedor.
                          </div>
                        </div>
                      );
                    })() : (
                      <div className="text-body-secondary mt-2" style={{ fontSize: 12 }}>
                        Calculando desglose...
                      </div>
                    )}

                  </div>
                ) : null}

                <button
                  type="button"
                  className="btn btn-dark w-100 mt-3 botonReservar"
                  disabled={
                    !fechaSeleccionada ||
                    (unidadEntrega === "Horas" && modoAgenda === "exacta" && !horarioExactoSeleccionado) ||
                    (unidadEntrega === "Horas" && modoAgenda === "flexible" && (franjaSeleccionada === "NA" || !horaSeleccionada)) ||
                    (servicio?.tipoDesplazamiento === "Domicilio" && (!direccionReserva.trim() || !referenciaReserva.trim() || (!servicio?.coberturaCompletaCiudad && (!subzonaReserva || subzonaReserva === "NA"))))
                  }
                  onClick={continuarAPagar}
                >
                  Continuar a pagar
                </button>

                {/* MÉTODOS DE PAGO ACEPTADOS */}
                <img
                  src="/imagenes/pagoswompi.png"
                  alt="Pagos seguros con Visa, Mastercard, American Express, DaviPlata, Nequi y PSE"
                  className="d-block mx-auto mt-3"
                  style={{ maxWidth: 340, width: "100%", height: "auto" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      : null}
    </div>
    }
    </div>
  );
}



export default Reserva;